import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
const apiurl = environment.apiUrl;
const checkIfFiles = (value: any): value is File[] => {
  return Array.isArray(value) && value.every(v => v instanceof File);
};
@Injectable({
  providedIn: 'root'
})
export class PostService {

  constructor(private readonly http: HttpClient, private readonly errorHandler: ErrorHandlerService,) { }

  createItem(data: FormData): Observable<any> {
    return this.http.post<any>(`${apiurl}/post`, data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  createItemWithImageString(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/post/create`, data
    ).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
  
  getItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/post`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  updateItem(data: any): Observable<any> {
    const images: (File | any)[] = data.image || [];
    const formData = new FormData();

    const newFiles: File[] = images.filter((i): i is File => i instanceof File);
    newFiles.forEach(file => formData.append('image', file));

    const oldImages = images.filter(i => !(i instanceof File));
    if (oldImages.length > 0) {
      formData.append('image', JSON.stringify(oldImages));
    }

    Object.keys(data).forEach(key => {
      if (key !== 'image') formData.append(key, data[key]);
    });

    return this.http.put<any>(`${apiurl}/post/${data.id}`, formData
    ).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  updateItemWithImageString(data: any): Observable<any> {
    return this.http.put<any>(`${apiurl}/post/${data.id}`, data).pipe(
      tap((response) => response)
    );
  }

  deleteItem(data: any) {
    return this.http.post<any>(`${apiurl}/post/delete`, data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getItemById(id: string) {
    return this.http.get<any>(`${apiurl}/post/${id}`).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getGroupOption(): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/option`).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getGroupItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/${1}`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getMainCategoryItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/${2}`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getCategoryItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/${3}`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getSubCategoryItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/${4}`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }


  FormDataByObject(obj: any, prop: string): FormData {
    const data = new FormData();
    Object.keys(obj).forEach((key) => {
      if (key !== prop) {
        const value = obj[key];

        if (Array.isArray(value)) {
          data.append(key, JSON.stringify(value));
        } else if (typeof value === 'object' && value !== null) {
          data.append(key, JSON.stringify(value));
        } else {
          data.append(key, value === null ? '' : value);
        }
      }
    });
    return data;
  }

  getUserPostStatus(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/post/user-post-status`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
  getBizPostStatus(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/post/biz-post-status`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getOverViewPostStatus(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/post/overview-post-stats`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
  getPostSearchHistoryStatus(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/post/search-history-stats`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
  getUploadImage(file: File, params: HttpParams = null): Observable<any> {
    const formData = new FormData();
    formData.append('image', file);

    return this.http.post<any>(`${apiurl}/post/upload-image`, formData, { params }).pipe(
      tap((response) => console.log('Upload response:', response)),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
}
